import { z } from 'zod';

import { schemaEuropaceFirma } from './Firma.schema';
import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#beamter

	{
		"beschaeftigungsverhaeltnis": {
			"arbeitgeber": Firma,
			"berufsbezeichnung": String,
			"beschaeftigtSeit": "YYYY-MM-DD",
			"inProbezeit": true | false,
			"nettoeinkommenMonatlich": schemaBigDecimal,
			"verbeamtetSeit": "YYYY-MM-DD"
		},
		"vorherigesBeschaeftigungsverhaeltnis": {
			"arbeitgeber": Firma,
			"beschaeftigtSeit": "YYYY-MM-DD",
			"beschaeftigtBis": "YYYY-MM-DD"
		}
	}

*/

export const schemaEuropaceBeamter = z.object({
    beschaeftigungsverhaeltnis: z.optional(
        z.object({
            arbeitgeber: z.optional(schemaEuropaceFirma),
            berufsbezeichnung: z.optional(z.string()),
            beschaeftigtSeit: z.optional(z.string().regex(regex_iso_date)),
            inProbezeit: z.optional(z.boolean()),
            nettoeinkommenMonatlich: z.optional(schemaBigDecimal),
            verbeamtetSeit: z.optional(z.string().regex(regex_iso_date)),
        }),
    ),
    vorherigesBeschaeftigungsverhaeltnis: z.optional(
        z.object({
            arbeitgeber: z.optional(schemaEuropaceFirma),
            beschaeftigtBis: z.optional(z.string().regex(regex_iso_date)),
            beschaeftigtSeit: z.optional(z.string().regex(regex_iso_date)),
        }),
    ),
});

export type SchemaEuropaceBeamter = z.infer<typeof schemaEuropaceBeamter>;
